export default __webpack_public_path__ + "static/media/icon-6.ac997969.png";